import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { AttributeError } from "../utils/validateAttributeName";

export const useAttributesError = (error: AttributeError) => {
  const { t } = useTranslation("dialogs");

  const userFriendlyErrors: Record<AttributeError, string> = useMemo(
    () => ({
      [AttributeError.EmptyName]: t("newLayer.emptyNameError"),
      // eslint-disable-next-line
      [AttributeError.InvalidFirstChar]: t("newLayer.invalidFirstCharError"),
      // eslint-disable-next-line
      [AttributeError.InvalidName]: t("newLayer.invalidNameError"),
      [AttributeError.DuplicateName]: t("newLayer.duplicateNameError"),
    }),
    [t],
  );

  return {
    help: userFriendlyErrors[AttributeError.InvalidName],
    error: userFriendlyErrors[error] || "",
  };
};
